// extracted by mini-css-extract-plugin
export default {"wrapper":"GalleryItem-module__wrapper___JZf3k"};